import { createReducer } from '@reduxjs/toolkit';

import { Loadable, RolesManager } from 'models';
import { makeThunkFromAPICall } from 'state';

export type RolesState = {
    roles: Loadable<RolesManager.Role[]>;
};

const initialState: RolesState = {
    roles: {
        status: 'idle',
    },
};

export const [getRoles, setRoles] = makeThunkFromAPICall(
    RolesManager.getRoles,
    'admin/roles',
);

export const rolesReducer = createReducer(initialState, (builder) => {
    builder.addCase(setRoles, (state, action) => {
        return {
            ...state,
            roles: { ...state.roles, ...action.payload.loadable },
        };
    });
});

export const RolesActions = {
    getRoles,
};

export default rolesReducer;
